import { Button } from '@ipfabric/ui-components/Button/Button';
import { ASSIGNABLE_RESERVED_LABEL_NAMES } from '@ipfabric/utils/labels';

type ReservedLabelNameSuggestionsProps = {
  onSelect: (name: string) => void;
};

export const ReservedLabelNameSuggestions = ({
  onSelect,
}: ReservedLabelNameSuggestionsProps) => (
  <div
    className='flex flex-wrap items-center gap-3xs'
    data-testid='reserved-label-name-suggestions'
  >
    <span className='text-sm text-secondary'>Reserved names:</span>
    {ASSIGNABLE_RESERVED_LABEL_NAMES.map((name) => (
      <Button
        dataTestId={`reserved-label-name-${name}`}
        key={name}
        onClick={() => onSelect(name)}
        type='button'
        variant='plain'
      >
        {name}
      </Button>
    ))}
  </div>
);
